
<template>
	<div>
	  <img class="gamekind_banner " src="../../images/aboutus_banner.png"/>
	  <div class="detailbox margin">
				<div class="title"><span>下载专区</span></div>
				<div class="load_area">
						<div class="top">
							<div class="top_left clearfix">
								 <span class="left">
								 	<img class="logoimg" :src='details.logo_img' align="top"/>
								 </span>
								 <span class="txt_right">
								 		<label>{{details.name}}</label>
								 		<label>大小：{{details.size}}MB</label>
								 		<label>下载：{{details.load_count}}万次下载</label>
								 </span>
								 <p class="cont">{{details.desp}}</p>
							</div>
							<div class="top_right">
								<h6>通过操作系统下载 >></h6>
								<a :href='details.ios_url' class="button first"><i class="ios"></i>ios下载</a>
								<a :href='details.android_url' class="button second"><i class="android"></i>android下载</a>
								<h6>二维码下载  >></h6>
								<div class="ercode clearfix">
									<img class="left" :src='details.ercodeimg'/>
									<span class="txt">通过手机扫描二维码，自动识别手机系统并从手机跳转下载页面</span>
								</div>
							</div>
						</div>
						<div class="bottom">
							<div class="imgs"><img class="listimg" :src='details.list_img1'/></div>
							<div class="imgs"><img class="listimg" :src='details.list_img2'/></div>
							<div class="imgs"><img class="listimg" :src='details.list_img3'/></div>
						</div>
				</div>
				<div v-show='details.cut_img1!=""'>
					<div class="title"><span>游戏截图</span></div>
					<div class="load_area">
						<div class="bottom">
							<div class="imgs"><img class="cutimg" :src='details.cut_img1'/></div>
							<div class="imgs"><img class="cutimg" :src='details.cut_img2'/></div>
							<div class="imgs"><img class="cutimg" :src='details.cut_img3'/></div>
						</div>
					</div>
				</div>
	  </div>
  </div>
</template>

<script>
export default {
		props: {
	        details: {
	          type: Object
	        }
	    }
}
</script>

<style lang="scss" scoped>
 @import '../../components/style/mixin';
 .gamekind_banner{
 		width:100%;
 		height:100%;
 		min-width:1000px;
 }
 .detailbox{
 		margin-top:30px;
 		.title{
 			position:relative;
 			@include sc(26px, #343434);
 			span{
 				padding-left:20px;
 			}
 		}
 		.title:before{
	 		position: absolute;
	    top: 5px;
	    bottom: 1px;
	    left: 5px;
	    display: inline-block;
	    content: '';
	    height: 25px;
	    border-left: 7px solid #fda00c;
 		}
 		.load_area{
 			margin-top:20px;
 			margin-bottom:40px;
 			padding:15px;
 			border:1px solid #cdcdcd;
 			box-shadow: 0  6px 10px #e4e4e4;
			.top{
				@include fj(center);
				.top_left{
					flex:1;
					padding-left:10px;
					.logoimg{
						@include wh(120px, 120px);
					}
					.txt_right{
						label{
							display: block;
							padding-left:137px;
							line-height:28px;
							text-align: left;
							@include sc(14px, #343434);
						}
						label:first-child{
							line-height:50px;
							@include sc(24px, #343434);
						}
					}
					.cont{
						margin-top:30px;
						@include sc(14px, #999);
					}
			  }
			  .top_right{
			  	  padding-left:20px;
			  	  width:400px;
			  	  h6{
			  	  	line-height:35px;
			  	  	margin-bottom:10px;
			  	  	@include sc(14px, #343434);
			  	  }
			  	  .button{
			  	  	display:inline-block;
			  	  	background-color:#ffbb03;
			  	  	@include wh(173px, 50px);
			  	  	line-height:50px;
			  	  	text-align: center;
			  	  	@include borderRadius(6px);
			  	  	@include sc(18px, #fff);
			  	  	cursor:pointer;
			  	  }
			  	  .first{
			  	  	margin-right:20px;
			  	  	.ios{
				  	  	display: inline-block;
				  	  	@include wh(19px, 24px);
				  	  	background:url(../../images/sc_1.png) no-repeat -2px -3px;
				  	  	vertical-align: middle;
				  	  	margin-right:5px;
				  	  	margin-bottom:5px;
			  	  	}
			  	  }
			  	  .second{
			  	  	.android{
				  	  	display: inline-block;
				  	  	@include wh(21px, 24px);
				  	  	background:url(../../images/sc_1.png) no-repeat -35px -3px;
				  	  	vertical-align: middle;
				  	  	margin-right:5px;
			  	  	}
			  	  }
			  	  .ercode{
			  	  	img{
			  	  		 @include wh(85px, 85px);
			  	  	}
			  	  	.left{
			  	  	   margin-right:10px;
			  	  	}
			  	  	.txt{
			  	  	   @include sc(14px, #999);
			  	  	}
			  	  }
			  }
			}
			.bottom{
				margin-top:10px;
				@include fj(center);
				.imgs{
					flex:1;
					text-align: center;
					.listimg{
						@include wh(300px, 540px);
					}
					.cutimg{
						@include wh(300px, 172px);
					}
				}
			}

 		}
 }

</style>
